const event = {};

/**
 * @description
 * Utility service to be reused across the application
 * to replace $rootScope.$emit, $rootScope.$on, $rootScope.$broadcast
 */
const eventManager = {

    eventsObservable: new Rx.BehaviorSubject(event),

    broadcast(newEvent, data, options) {

        this.eventsObservable.onNext({ newEvent, data, options });

    },

    subscribe(eventName, callback) {

        this.eventsObservable.subscribe(({ newEvent, data, options }) => {

            if (newEvent === eventName) {

                callback(data, options);

            }


        });


    },

};

export default eventManager;



// WEBPACK FOOTER //
// ./scripts/common/services/-RFC.eventManager.js